var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-left" }, [
    _vm.componentReady
      ? _c("div", [
          _c("h5", {
            domProps: {
              textContent: _vm._s(_vm.t("forms.new_contractor_jurs.IC_0001")),
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "small-12 medium-5 columns" }, [
              _c("h6", {
                domProps: {
                  textContent: _vm._s(
                    _vm.t("forms.new_contractor_jurs.IC_0003")
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.availableText,
                      expression: "availableText",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.t("register.filter_jurs"),
                    type: "text",
                  },
                  domProps: { value: _vm.availableText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.availableText = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.regionSelected,
                      expression: "regionSelected",
                    },
                  ],
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.regionSelected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                [
                  _c("option", {
                    attrs: { value: "0" },
                    domProps: {
                      textContent: _vm._s(_vm.t("register.filter_region")),
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.jurInfo.allRegions, function (region) {
                    return _c("option", {
                      domProps: {
                        value: region.value,
                        textContent: _vm._s(region.name),
                      },
                    })
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.jursSelected,
                      expression: "jursSelected",
                    },
                  ],
                  attrs: { multiple: "", size: "15" },
                  on: {
                    dblclick: _vm.addToSelected,
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.jursSelected = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.availableJurs, function (jurs) {
                  return _vm.jursNotSelected(jurs.value)
                    ? _c("option", {
                        attrs: { title: jurs.name },
                        domProps: {
                          value: jurs.value,
                          textContent: _vm._s(jurs.name),
                        },
                      })
                    : _vm._e()
                }),
                0
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "small-12 medium-2 columns text-center" },
              [
                _c("div", [
                  _c(
                    "div",
                    { staticStyle: { top: "220px", position: "relative" } },
                    [
                      _c("a", {
                        staticClass: "fa fa-angle-double-left fa-2x grow",
                        on: { click: _vm.removeFromSelected },
                      }),
                      _vm._v(" "),
                      _c("a", {
                        staticClass: "fa fa-angle-double-right fa-2x grow",
                        on: { click: _vm.addToSelected },
                      }),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "small-12 medium-5 columns" }, [
              _c("h6", {
                domProps: {
                  textContent: _vm._s(
                    _vm.t("forms.new_contractor_services.IC_0004")
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedText,
                      expression: "selectedText",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.t("register.filter_jurs"),
                    type: "text",
                  },
                  domProps: { value: _vm.selectedText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.selectedText = $event.target.value
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.jursCurrent,
                      expression: "jursCurrent",
                    },
                  ],
                  staticStyle: { "margin-top": "45px" },
                  attrs: { multiple: "", size: "15" },
                  on: {
                    dblclick: _vm.removeFromSelected,
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.jursCurrent = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.currentJurs, function (jurs) {
                  return _c("option", {
                    attrs: { title: jurs.name },
                    domProps: {
                      value: jurs.value,
                      textContent: _vm._s(jurs.name),
                    },
                  })
                }),
                0
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "columns small-12 text-center" }, [
              _c("button", {
                staticClass: "tiny navBtn",
                domProps: {
                  textContent: _vm._s(
                    _vm.t("forms.new_blank_reference_member.IC_0024")
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.checkComplete()
                  },
                },
              }),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.componentReady
      ? _c("div", [_c("i", { staticClass: "fa fa-spinner fa-spin fa-2x" })])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }